/* eslint-disable */
// Chakra imports
import {
  Box,
  SimpleGrid,
  useColorModeValue,
  Icon,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  useDisclosure,
} from "@chakra-ui/react";

import MiniStatistics from "components/card/MiniStatistics";
import IconBox from "components/icons/IconBox";
import React, { useEffect, useState } from "react";

import {
  MdAssignment,
  MdPendingActions,
  MdPriorityHigh,
  MdCheckCircle,
} from "react-icons/md";

import ComplexTable from "views/admin/dashboard_teknisi/components/ComplexTable";
import axiosClient from "../../../api/axiosClient";

export default function UserReports() {
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");

  const userId = localStorage.getItem("id_pegawai");

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [telegramUrl, setTelegramUrl] = useState(null);

  const [stats, setStats] = useState({
    total_ticket: 0,
    status_summary: {
      diproses: 0,
    },
    urgent_ticket: 0,
    selesai_bulan_ini: 0,
  });

  const [tickets, setTickets] = useState([]);
  const [urgentTickets, setUrgentTickets] = useState([]);

  const fetchTelegramConnect = async () => {
    try {
      const res = await axiosClient.get("/notifications/telegram/connect");

      setTelegramUrl(res.data.url);
      onOpen();
    } catch (error) {
      console.error("Gagal connect telegram", error);
    }
  };

  useEffect(() => {
    const chatId = localStorage.getItem("telegram_chat_id");

    if (!chatId || chatId === "null" || chatId === "undefined") {
      fetchTelegramConnect();
    }
  }, []);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await axiosClient.get(
          `/tickets/statistik_teknisi/${userId}`
        );

        setStats(res.data);
      } catch (error) {
        console.error("Gagal ambil statistik teknisi", error);
      }
    };

    if (userId) {
      fetchStats();
    }
  }, [userId]);

  useEffect(() => {
    const fetchTickets = async () => {
      try {
        const res = await axiosClient.get(
          `/tickets/track-assigne-me/${userId}`
        );

        const data = res.data.data || [];

        setTickets(data);

        const urgent = data.filter(
          (t) => t.urgensi?.toLowerCase() === "tinggi"
        );

        setUrgentTickets(urgent);
      } catch (error) {
        console.error("Gagal ambil ticket teknisi", error);
      }
    };

    if (userId) {
      fetchTickets();
    }
  }, [userId]);

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        columns={{ base: 1, sm: 2, md: 2, lg: 4 }}
        spacing={{ base: "12px", md: "20px" }}
        mb="20px"
      >
        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon w="28px" h="28px" as={MdAssignment} color={brandColor} />
              }
            />
          }
          name="Total Ticket Saya"
          value={stats.total_ticket || 0}
        />

        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon
                  w="28px"
                  h="28px"
                  as={MdPendingActions}
                  color="orange.400"
                />
              }
            />
          }
          name="Sedang Diproses"
          value={stats.status_summary?.diproses || 0}
        />

        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon w="28px" h="28px" as={MdPriorityHigh} color="red.400" />
              }
            />
          }
          name="Prioritas Tinggi"
          value={stats.urgent_ticket || 0}
        />

        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon w="28px" h="28px" as={MdCheckCircle} color="green.400" />
              }
            />
          }
          name="Selesai Bulan Ini"
          value={stats.selesai_bulan_ini || 0}
        />
      </SimpleGrid>

      <SimpleGrid columns={{ base: 1, xl: 2 }} spacing="20px">
        <Box w="100%">
          <ComplexTable title="Ticket Aktif Saya" tableData={tickets} />
        </Box>

        <Box w="100%">
          <ComplexTable
            title="Ticket Prioritas Tinggi"
            tableData={urgentTickets}
          />
        </Box>
      </SimpleGrid>

      <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered>
        <ModalOverlay />
        <ModalContent borderRadius="20px">
          <ModalHeader>Hubungkan Telegram</ModalHeader>
          <ModalCloseButton />

          <ModalBody pb={6}>
            <Text mb={4}>
              Akun kamu belum terhubung dengan Telegram. Klik tombol di bawah,
              lalu tekan <b>START</b> di Telegram untuk mengaktifkan notifikasi
              ticket.
            </Text>

            {telegramUrl && (
              <Button
                colorScheme="blue"
                w="100%"
                mb={4}
                onClick={() => window.open(telegramUrl, "_blank")}
              >
                Buka Telegram
              </Button>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
}